exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".u-myimage[data-v-7af529be]{border:none !important}[data-v-7af529be] .image-slot{width:100%;height:100%;display:flex;align-items:center;justify-content:center}\n", ""]);

// exports
